import { render } from "./FeaturedPackages.vue?vue&type=template&id=57a03a89"
import script from "./FeaturedPackages.vue?vue&type=script&lang=js"
export * from "./FeaturedPackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__